import * as contactsModule from '@/store/contacts/contactsModule'

export const state = Object.assign({}, contactsModule.defaults())

export default {
  namespaced: true,
  state,
  mutations: contactsModule.mutations,
  actions: contactsModule.actions,
  getters: contactsModule.getters
}



// WEBPACK FOOTER //
// ./src/store/administration/clients/clientContactsModule.js